(() => {
        if (window.__mellerChileCartBadgeLiteLoaded) return;
        window.__mellerChileCartBadgeLiteLoaded = true;

        const BADGE_SELECTOR = [
          '.cart-count-bubble',
          '[data-cart-count-bubble]',
          '.cart-bubble',
          '.cart-icon__bubble',
          '.header-actions__cart-count',
          '.header__cart-count',
          '[data-cart-count]',
          '.cart-count'
        ].join(',');

        let syncTimer = null;
        let lastKnownCount = null;

        const getHeaderRoot = () => {
          return document.getElementById('header-group') || document.querySelector('header') || document;
        };

        const getBadgeElements = () => {
          const root = getHeaderRoot();
          if (!root) return [];
          return Array.from(new Set(root.querySelectorAll(BADGE_SELECTOR)));
        };

        const hasBadge = () => getBadgeElements().length > 0;

        const getVisibleCounter = (badge) => {
          const explicit = badge.querySelector('[data-meller-cart-count-text], [data-cart-count]:not(.visually-hidden)');
          if (explicit) return explicit;

          const ariaHidden = badge.querySelector('[aria-hidden="true"]:not(.visually-hidden)');
          if (ariaHidden && !ariaHidden.querySelector('svg')) return ariaHidden;

          const span = Array.from(badge.querySelectorAll('span:not(.visually-hidden)')).find((element) => {
            return !element.querySelector('svg') && !element.matches('.cart-bubble__background, .cart-count-bubble__background');
          });

          if (span) return span;

          if (!badge.children.length) return badge;

          const created = document.createElement('span');
          created.setAttribute('aria-hidden', 'true');
          created.setAttribute('data-meller-cart-count-text', '');
          badge.insertBefore(created, badge.firstChild);
          return created;
        };

        const setBadgeCount = (badge, count) => {
          const normalizedCount = Math.max(0, Number(count) || 0);
          const counter = getVisibleCounter(badge);

          if (counter) {
            counter.textContent = String(normalizedCount);
            counter.setAttribute('aria-hidden', 'true');
          }

          badge.querySelectorAll('.visually-hidden').forEach((hiddenText) => {
            hiddenText.textContent = normalizedCount === 1 ? '1 producto en tu carrito' : `${normalizedCount} productos en tu carrito`;
          });

          badge.setAttribute('data-meller-cart-count-fixed', String(normalizedCount));

          if (normalizedCount > 0) {
            badge.hidden = false;
            badge.removeAttribute('hidden');
            badge.style.display = '';
            badge.style.visibility = 'visible';
            badge.style.opacity = '1';
          } else {
            badge.hidden = true;
            badge.setAttribute('hidden', '');
          }
        };

        const applyCartCount = (count) => {
          if (count === null || count === undefined) return;
          lastKnownCount = Math.max(0, Number(count) || 0);
          getBadgeElements().forEach((badge) => setBadgeCount(badge, lastKnownCount));
        };

        const fetchCartCount = async () => {
          try {
            const response = await fetch('/cart.js', {
              method: 'GET',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              cache: 'no-store'
            });

            if (!response.ok) return null;

            const cart = await response.json();
            const count = Number(cart && cart.item_count);
            return Number.isFinite(count) ? Math.max(0, count) : null;
          } catch (error) {
            return null;
          }
        };

        const syncCartBadge = (delay = 180) => {
          window.clearTimeout(syncTimer);
          syncTimer = window.setTimeout(async () => {
            if (!hasBadge()) return;
            const count = await fetchCartCount();
            applyCartCount(count);
          }, delay);
        };

        const handleCartEvent = (event) => {
          const detail = event && event.detail;
          const data = detail && detail.data;

          if (data && data.didError) return;

          if (data && data.source === 'cart-items-component' && Number.isFinite(Number(data.itemCount))) {
            applyCartCount(Number(data.itemCount));
            return;
          }

          syncCartBadge(220);
        };

        document.addEventListener('cart:update', handleCartEvent, { passive: true });

        document.addEventListener(
          'submit',
          (event) => {
            const form = event.target;
            if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
            syncCartBadge(900);
          },
          true
        );

        window.addEventListener('pageshow', (event) => {
          if (event.persisted) syncCartBadge(0);
        });

        const scheduleInitialSync = () => {
          if (!hasBadge()) return;

          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(() => syncCartBadge(0), { timeout: 3500 });
          } else {
            window.setTimeout(() => syncCartBadge(0), 1800);
          }
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', scheduleInitialSync, { once: true });
        } else {
          scheduleInitialSync();
        }
      })();

